<template>

	<div class="bkf7 gameall_list">
		<el-container>
			<div class="inter">


				<div class="filter-content" style="margin-bottom: 20px;">
					<div class="filter-content-map">

						<div class="filter-list filter-script-list">
							<div class="filter-script">



								<div class="filter-item">
									<div class="filter-item-label">大区</div>
									<div class="filter-item-content">
										<div class="filter-item-options" style="height: auto;">

											<div class="opt-list">
												<div class="opt-item" @click="daquchange({ id: 0 })"
													:class="{ 'opt-item_active': 0 == daqu }">
													<div class="opt-item-name ellipsis-2">
														全部
													</div>
												</div>
												<div class="opt-item" @click="daquchange(item)"
													:class="{ 'opt-item_active': item.id == daqu }"
													v-for="item in channellist">
													<div class="opt-item-name ellipsis-2">
														{{ item.name }}
													</div>
												</div>
											</div>



										</div>
									</div>
								</div>


								<div class="filter-item" v-if="daqu != 0">
									<div class="filter-item-label">服务器</div>
									<div class="filter-item-content">
										<div class="filter-item-options" style="height: auto;">

											<div class="opt-list">
												<div class="opt-item" @click="fuwqichange({ id: 0 })"
													:class="{ 'opt-item_active': 0 == fuwuqi }">
													<div class="opt-item-name ellipsis-2">
														全部
													</div>
												</div>
												<div class="opt-item" @click="fuwqichange(item)"
													:class="{ 'opt-item_active': item.id == fuwuqi }"
													v-for="item in server_list">
													<div class="opt-item-name ellipsis-2">
														{{ item.name }}
													</div>
												</div>
											</div>



										</div>
									</div>
								</div>

								<div class="filter-item" v-if="show_filter" v-for="(item, index) in filterlist">
									<div class="filter-item-label">{{ item.title }}</div>
									<div class="filter-item-content">
										<div class="filter-item-options"
											:class="{ 'filter-item-options_expand': show_list[item.name].show }">
											<div class="opt-list">
												<div class="opt-item" @click="choseFilter(index, item1.value)"
													:class="{ 'opt-item_active': item1.active }"
													v-for="item1 in item.content">
													<div class="opt-item-name ellipsis-2">
														{{ item1.title }}
													</div>
												</div>
											</div>
											<div class="opt-more"
												v-show="!show_list[item.name].show && show_list[item.name].extend == 'more'"
												@click="openShow(item.name)">
												更多
												<img :src="require(`@/assets/image/jiantou_n.png`)">
											</div>
											<div class="opt-more"
												v-show="show_list[item.name].show && show_list[item.name].extend == 'more'"
												@click="openShow(item.name)">
												收起
												<img :src="require(`@/assets/image/jiantou_n.png`)">
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="filter-section" style="padding-top: 20px;">
							<div class="filter-section-label">区间搜索</div>
							<div class="filter-section-list">

								<div class="section-item">
									<div class="item-label">
										价格
									</div>
									<div class="item-field">
										<el-input v-model="filter.strprice" @change="strpricechange" placeholder="最低值">
										</el-input>
										<div class="line"></div>
										<el-input v-model="filter.endprice" @change="endpricechange" placeholder="最高值">
										</el-input>
									</div>
								</div>
							</div>
						</div>
						<div class="filter-keywords-search">
							<div class="filter-search-label">关键词</div>
							<div class="filter-search-info">


								<div class="filter-search-input el-input el-input--suffix">
									<input type="text" autocomplete="off" v-model="keyword" placeholder="请输入关键字"
										class="el-input__inner"><span class="el-input__suffix">
										<span class="el-input__suffix-inner" @click="Search">
											<div class="search">搜索</div>
										</span></span>

								</div>


							</div>
						</div>

					</div>





					<div class="filter-quick">
						<div class="quick-item" :class="{ 'quick-item_active': flag.includes('fangxin') }"
							@click="choseFlag('fangxin')">放心购</div>
						<div class="quick-item" :class="{ 'quick-item_active': flag.includes('bao') }"
							@click="choseFlag('bao')">可买包赔
						</div>
						<div class="quick-item" :class="{ 'quick-item_active': flag.includes('bubao') }"
							@click="choseFlag('bubao')">
							不可包赔</div>
						<div class="quick-item" :class="{ 'quick-item_active': flag.includes('top') }"
							@click="choseFlag('top')">顶级账号
						</div>

					</div>

				</div>


				<el-row>
					<div class="sortpaixu">
						<ul class="sortpaixu_ul">
							<li :class="{ 'active': sortactive == 1 }" @click="chose_sort(1)"><span>默认排序</span></li>
							<li :class="{ 'active': sortactive == 2 }" @click="chose_sort(2, sort_time)">
								<span>发布时间</span><span v-if="sortactive == 2 && sort_time == 0">↑</span><span
									v-if="sortactive == 2 && sort_time == 1">↓</span>
							</li>
							<li :class="{ 'active': sortactive == 3 }" @click="chose_sort(3, sort_price)">
								<span>价格</span><span v-if="sortactive == 3 && sort_price == 0">↑</span><span
									v-if="sortactive == 3 && sort_price == 1">↓</span>
							</li>
						</ul>


					</div>
				</el-row>
				<div class="zh_wcontent">


					<el-row>


						<div v-show="loading" style="padding: 20px;" v-loading="loading" element-loading-text="加载中"
							element-loading-spinner="el-icon-loading">
							<el-skeleton :rows="6" animated />
						</div>

						<router-link :title="item.title" target="_blank"
							:to="{ path: '/goodsdetail', query: { id: item.id } }" v-for="item in flowList"
							v-show="!loading">

							<div class="newGoodsList_box">
								<div class="el-image newGoodsList_box_img">
									<el-image :src="item.image" lazy></el-image>
								</div>
								<div class="newGoodsList_box_info">
									<div class="newGoodsList_box_info_top">
										<h4 class="ellipsis-2">{{ item.title }}</h4>
									</div>
									<div class="newGoodsList_box_info_bottom">
										<p class="newGoodsList_box_info_bottom_qf">
											{{ item.channel.name }}-{{ item.daqu_name }}-{{ item.server_name }}
										</p>
										<div class="newGoodsList_box_info_time"><span>发布时间:
												{{ item.publishtime }}</span>
											<span><img src="https://oss.pzds.com/pc-ssr-im/goodsList_Icon4.png" alt="">
												{{ item.views }}人
											</span>
										</div>
										<div class="newGoodsList_box_lable">


											<img width="60px" height="16px" v-if="item.flag.includes('top')"
												:src="require(`@/assets/image/top.png`)">
											<img width="60px" height="16px" v-if="item.flag.includes('bao')"
												:src="require(`@/assets/image/bao.png`)">
											<img width="60px" height="16px" v-if="item.flag.includes('bubao')"
												:src="require(`@/assets/image/bubao.png`)">
											<img width="60px" height="16px" v-if="item.flag.includes('fangxin')"
												:src="require(`@/assets/image/fangxin.png`)">
										</div>
									</div>
								</div>
								<div class="newGoodsList_box_pir">￥{{ item.price }}</div>
							</div>
						</router-link>




						<el-pagination class="pagebox" background @size-change="handleSizeChange"
							@current-change="handleCurrentChange" :current-page="current_page"
							:page-sizes="[10, 20, 30, 40, 50]" :page-size="10"
							layout="total, sizes, prev, pager, next, jumper" :total="total">
						</el-pagination>

					</el-row>
				</div>
			</div>
		</el-container>
	</div>

</template>
<script>
export default {
	data() {
		return {
			query: [],
			daqu_list: [],
			server_list: [],
			server_show: false,
			channel: 0,
			daqu: 0,
			fuwuqi: 0,
			order: 1,
			flowList: [],
			filter_chose: [],
			filterlist: [],
			fbeifen: [],
			channeldata: [],
			current_page: 1,
			pagesize: 10,
			total: 0,
			last_page: 0,
			filter: {
				strprice: '',
				endprice: '',
			},
			loadStatus: 'loadmore',
			strprice: '',
			endprice: '',
			keyword: '',
			sortactive: 1,
			sort_time: 0,
			sort_price: 0,
			is_zu: 0,
			acc_type: "1",
			loading: true,
			priceindex: -1,
			q:"",
			pricelist: [{
				min: 500,
				max: 4999
			},
			{
				min: 5000,
				max: 9999
			},
			{
				min: 10000,
				max: 14999
			},
			{
				min: 15000,
				max: 19999
			},
			{
				min: 20000,
				max: 9999999
			}
			],
			channellist: [],
			flag: [],
			show_list: {},
			first: true,
			show_filter: true


		}
	},
	created: function (data) {

		this.value = this.$route.query.gtype;
		this.keyword = this.$route.query.keyword;
		this.channel = this.$route.query.gtype;
		this.getchannellist(this.$data.channel);
		this.addRandomData(this.$data.channel, this.$data.current_page);

		// this.getFilterList()

	},
	watch: {
		$route() {
			this.$data.value = this.$route.query.gtype;
			this.$data.keyword = this.$route.query.keyword;
			this.$data.channel = this.$route.query.gtype;
			this.getchannellist(this.$data.channel);
			this.$data.current_page = 1;
			this.$data.pagesize = 10;
			this.addRandomData(this.$data.channel, this.$data.current_page);

			// this.getFilterList()
		}
	},
	methods: {

		Search(){
			this.current_page = 1;
			this.pagesize = 10;
			this.addRandomData(this.channel, this.current_page);
		},
		openShow(name) {
			this.show_filter = false


			this.show_list[name].show = !this.show_list[name].show
			this.show_filter = true

		},
		choseFlag(item) {
			let res = this.flag.indexOf(item);
			if (res !== -1) {
				// 存在则删除该值
				this.flag.splice(res, 1);
			} else {
				// 不存在则添加该值
				this.flag.push(item);
			}


			this.current_page = 1;
			this.pagesize = 10;
			this.addRandomData(this.channel, this.current_page);
		},
		choseFilter(index, value) {

			var type = this.filterlist[index].type
			console.log(type)
			if (value == '') {
				this.filter_chose[index].value = [value];
				this.current_page = 1;
				this.pagesize = 10;
				this.addRandomData(this.channel, this.current_page);
				return;
			}

			if (type == 'selects') {
				if (value != '') {
					let res = this.filter_chose[index].value.indexOf('');

					if (res !== -1) {
						// 存在则删除该值
						this.filter_chose[index].value.splice(res, 1);
					}
				}

				let res = this.filter_chose[index].value.indexOf(value);
				if (res !== -1) {
					// 存在则删除该值
					this.filter_chose[index].value.splice(res, 1);
				} else {
					// 不存在则添加该值
					this.filter_chose[index].value.push(value);
				}
			} else {
				this.filter_chose[index].value = [];
				this.filter_chose[index].value = [value];
			}


			console.log(this.filter_chose[index])
			this.current_page = 1;
			this.pagesize = 10;
			this.addRandomData(this.channel, this.current_page);
		},

		chose_sort(index, name) {
			this.$data.sortactive = index;

			switch (index) {
				case 1:
					this.$data.order = 1;
					this.$data.sort_time = 0;
					this.$data.sort_price = 0;
					break;
				case 2:
					this.$data.sort_price = 0;
					if (name == 0) {
						this.$data.sort_time = 1;
						this.$data.order = 1;
					} else {
						this.$data.sort_time = 0;
						this.$data.order = 2;
					}
					break;
				case 3:
					this.$data.sort_time = 0;
					if (name == 0) {
						this.$data.sort_price = 1;
						this.$data.order = 4;
					} else {
						this.$data.sort_price = 0;
						this.$data.order = 3;
					}
					break;
			}



			this.$data.current_page = 1;
			this.addRandomData(this.$data.channel, this.$data.current_page, this.$data.total);


		},

		getchannellist(id) {
			this.rq.requests.post("/api/game/Hall/getchannellist", {
				id: id,

			}).then(res => {

				this.channellist = res.data;
			}).catch(error => {

			})
		},




		addRandomData(id, current_page, pagesize) {
			this.loading = true;
			var that = this;
			var filter = {};
			filter = this.$data.filter;
			filter.daqu = this.$data.daqu;
			filter.fuwuqi = this.$data.fuwuqi;
			filter.q = this.$data.key;



			filter.filter_chose = that.filter_chose,
				filter.flag = that.flag,

				filter = JSON.stringify(filter);
			filter = encodeURIComponent(filter);



			this.rq.requests.post("api/game/hall/getCarchives", {
				id: id,
				daqu: that.daqu,
				fuwuqi: that.fuwuqi,
				page: current_page,
				filter: filter,
				order: that.order,
				pagesize: that.pagesize,
				keyword: that.keyword,
			}).then(res => {
				that.last_page = res.data.list.last_page;

				that.filter_chose = res.data.filter;
				that.filterlist = res.data.filterlist;
				that.current_page = res.data.list.current_page;
				that.total = res.data.list.total;

				for (let i = 0; i < that.filterlist.length; i++) {

					if (!that.show_list[that.filterlist[i].name]) {
						that.show_list[that.filterlist[i].name] = {
							show: that.filterlist[i].show,
							extend: that.filterlist[i].extend

						};


					}
				}




				that.flowList = res.data.list.data;
				that.loading = false
				that.flag = res.data.flag;

			}).catch(error => {

			})
		},

		handleSizeChange(val) {

			this.pagesize = val;
			this.addRandomData(this.$data.channel, this.$data.current_page, val);
		},
		handleCurrentChange(val) {
			this.current_page = val;
			this.addRandomData(this.$data.channel, this.$data.current_page, this.$data.total);
		},
		strpricechange() {

			this.addRandomData(this.$data.channel, this.$data.current_page, this.$data.total);
		},
		endpricechange() {
			this.addRandomData(this.$data.channel, this.$data.current_page, this.$data.total);
		},
		//选择大区
		daquchange(value) {

			if (value.id == 0) {
				this.server_list = [];

			} else {
				this.server_list = value.childlist
			}

			this.fuwuqi = 0;

			this.daqu = value.id;
			this.current_page = 1;
			this.addRandomData(this.$data.channel, this.$data.current_page, this.$data.total);


		},
		//选择服务器
		fuwqichange(value) {

			this.fuwuqi = value.id;
			this.current_page = 1;
			this.addRandomData(this.$data.channel, this.$data.current_page, this.$data.total);
		}

	}
}
</script>
<style>
.zuhao .el-radio__input {
	display: flex !important;
	align-items: center;
}

.zuhao .el-radio__input.is-checked .el-radio__inner {
	border-color: #508aff;
	background: #508aff;
}

.zuhao .el-radio__input.is-checked+.el-radio__label {
	color: #508aff;
}
</style>